import { Box } from "@mui/material";
import { useStore } from "@tanstack/react-form";

import { withForm } from "components/Forms/AppForm";

import { ppFilterDefaultValues } from "../../context/ppFilterDefaultValues";
import { useFilteredPps } from "../../hooks/useFilteredPps";

import PpCard from "./PpCard";

const PpGridView = withForm({
  defaultValues: ppFilterDefaultValues,
  render: function Render({ form }) {
    const filters = useStore(form.store, (state) => state.values);
    const { protectionProfiles } = useFilteredPps(filters);

    return (
      <Box display="flex" flexWrap="wrap" p={2}>
        {protectionProfiles?.map((pp) => {
          if (!pp) return null;

          return (
            <Box key={pp.pp_id} flex="1 1 calc(50% - 2em)" margin="1em">
              <PpCard card={pp} />
            </Box>
          );
        })}
      </Box>
    );
  },
});

export default PpGridView;
